import { FC, ReactNode, createContext, useContext } from 'react';

type WbDrawerContextType = {
  open: boolean;
  setOpen: (open: boolean) => void;
  canClose: boolean;
  lockClosure: () => void;
  unlockClosure: () => void;
};

const defaultWbDrawerContext = null;

export const WbDrawerContext = createContext<WbDrawerContextType | null>(
  defaultWbDrawerContext,
);

export const useWbDrawerContext = () => {
  const contextValue = useContext(WbDrawerContext);

  if (!contextValue) {
    throw new Error(
      'useWbDrawerContext has to be used within <WbDrawerContext.Provider>',
    );
  }

  return contextValue;
};

export const WbDrawerContextProvider: FC<{
  children: ReactNode;
  value: WbDrawerContextType;
}> = ({ children, value }) => {
  return (
    <WbDrawerContext.Provider value={value}>
      {children}
    </WbDrawerContext.Provider>
  );
};
